import { useEffect, useRef, useState } from "react";
import { animate, useReducedMotion } from "framer-motion";

/* Número que «se cuenta» desde el valor anterior (o 0) hasta el nuevo, con frenado suave.
   Con «reducir movimiento» activado en el equipo, muestra el valor final directo. */
export default function Cuenta({ valor, fmt = (v) => String(Math.round(v)), dur = 1.1 }) {
  const reducido = useReducedMotion();
  const desde = useRef(0);
  const [v, setV] = useState(reducido ? Number(valor) || 0 : 0);
  useEffect(() => {
    const hasta = Number(valor) || 0;
    if (reducido) { setV(hasta); desde.current = hasta; return undefined; }
    const c = animate(desde.current, hasta, { duration: dur, ease: [0.22, 1, 0.36, 1], onUpdate: setV });
    desde.current = hasta;
    return () => c.stop();
  }, [valor, reducido, dur]);
  return <>{fmt(v)}</>;
}
